import { render, staticRenderFns } from "./SVGTemplate.vue?vue&type=template&id=203676f9&scoped=true&"
import script from "./SVGTemplate.vue?vue&type=script&lang=ts&"
export * from "./SVGTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./SVGTemplate.vue?vue&type=style&index=0&id=203676f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203676f9",
  null
  
)

export default component.exports